module.exports = __webpack_public_path__ + "grass-instance-3.c1f65d8d26034cd00fc66a94221aa054.png";